// extracted by mini-css-extract-plugin
module.exports = {"limit-count":"LimitedTextarea_limit-count__nolYq","limit-count-warning":"LimitedTextarea_limit-count-warning__ZZ8Xz"};